import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";

class SexOffenderNimbus extends Component {
  componentDidMount() { }

  render() {
    let sourceName = `${_.get(
      this.props.node,
      "crimeDetailsRecords[0].crimeDetails[0].sourceState[0]._",
      ""
    )} ${_.get(
      this.props.node,
      "crimeDetailsRecords[0].crimeDetails[0].disposition[0]._",
      ""
    )}`;
    if (sourceName === " ") {
      sourceName = _.get(
        this.props.node,
        "arrestDetailsRecords[0].crimeDetails[0].sourceState[0]._",
        ""
      );
      if (sourceName === "") {
        sourceName = _.get(
          this.props.node,
          "warrantDetailsRecords[0].crimeDetails[0].sourceState[0]._",
          ""
        );
      }
    }
    let offense = _.get(
      this.props.node,
      "crimeDetailsRecords[0].crimeDetails[0].offenseDescription1[0]._",
      ""
    );
    if (offense === "") {
      offense = _.get(
        this.props.node,
        "arrestDetailsRecords[0].crimeDetails[0].charges[0]._",
        ""
      );
      if (offense === "") {
        offense = _.get(
          this.props.node,
          "warrantDetailsRecords[0].crimeDetails[0].charges[0]._",
          ""
        );
      }
    }
    return (
      <Table
        key={`InstantCriminal_Table_${this.props.index}`}
        className={`sub-table`}
      >
        <Table.Body>
          <Table.Row>
            <Table.Cell width={2} className={"sub-table-cell text-bold"}>
              Name:
            </Table.Cell>
            <Table.Cell width={3} className={"sub-table-cell"}>
              {this.props.name}
            </Table.Cell>
            <Table.Cell width={2} className={"sub-table-cell text-bold"}>
              State:
            </Table.Cell>
            <Table.Cell width={5} className={"sub-table-cell"}>
              {/* {states.join(", ")} */}
              {sourceName}
            </Table.Cell>
          </Table.Row>
          <Table.Row className={"table-no-border"}>
            <Table.Cell width={2} className={"sub-table-cell text-bold"}>
              Date Of Birth:
            </Table.Cell>
            <Table.Cell width={3} className={"sub-table-cell"}>
              {this.props.dob}
            </Table.Cell>
            <Table.Cell width={2} className={"sub-table-cell text-bold"}>
              Offense:
            </Table.Cell>
            <Table.Cell width={5} className={"sub-table-cell"} colSpan={3}>
              {offense}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }
}

export default SexOffenderNimbus;



// WEBPACK FOOTER //
// ./src/components/searchresults/SexOffenderNimbus.js